import { Component, OnInit, Inject, ViewChild, ElementRef, Input} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DOCUMENT } from "@angular/platform-browser";
import { FileUpload } from "../../shared/app/classes/file-upload";
import { HttpClientModule } from "@angular/common/http";
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PayeeSubmission, PayeeAttachment, PayeeAttachmentDetail, SubmissionSubtagMapping} from '../../shared/sdk/models';
import { PayeeApi, StorageApi ,PayeeSubmissionApi } from '../../shared/sdk/services';
import { FormPage } from '../../shared/app/classes/form-page'
import { GlobalEventsManager } from '../../events-manager.component';
import { SubmissionDetailService } from "../../shared/app/services/";
import { LoopBackConfig } from "../../shared/sdk/lb.config";

@Component({
  selector: 'jompay-offer-letter',
  templateUrl: 'jompay-offer-letter.component.html',
  providers: [
    { provide: 'Window',  useValue: window }
  ],
  styleUrls: ['../application.css']
})

export class JompayOfferLetterComponent implements OnInit {
  @ViewChild('offerLetter') offerLetter: ElementRef;
  @ViewChild('serviceAgreement') serviceAgreement: ElementRef;
  @ViewChild('authLetterCollectionAcc') authLetterCollectionAcc: ElementRef;

  TAG = 'JompayOfferLetterComponent';
  offerletterSrc: any;
  serviceAgreementSrc: any;
  authLetterCollectionAccSrc: any;

  @Input() submission: any;
  constructor(
    public payeeApi: PayeeApi,
    public payeeSubmissionApi: PayeeSubmissionApi,
    public router: Router,
    public storageApi: StorageApi,
    public eventsManager: GlobalEventsManager,
    public submissionDetailService: SubmissionDetailService,
    public sanitizer: DomSanitizer,
    public http: HttpClientModule,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  // Initialisation
  async ngOnInit() {
    // console.log(this.TAG + "getOfferLetter: ");

    this.getOfferLetter().subscribe(
      (res: PayeeSubmission) => {
        this.eventsManager.loaded(true);
        console.log(this.TAG + ' === Attachments: ');
        console.log(res);

        if (res.attachments.length > 0) {
          for (let attachment of res.attachments) {
            if (attachment.type === 'jompay_offer_letter') {
                this.offerletterSrc = LoopBackConfig.getPath() + '/' + LoopBackConfig.getApiVersion() +
                  '/storages/' + this.payeeApi.getCurrentId() + '/download/' + attachment.file_name +
                  '?access_token=' + this.payeeApi.getCurrentToken().id;
            }
          }
        }
        this.serviceAgreementSrc = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/doc/download/JomPAY_Payment_Collection_Agreement.pdf" + "?access_token=" + this.payeeApi.getCurrentToken().id;
        this.authLetterCollectionAccSrc = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/doc/download/Letter_of_Authorisation_Collection_Account_template.docx" + "?access_token=" + this.payeeApi.getCurrentToken().id;
      },
      err => {
        this.eventsManager.loaded(true);
        console.log(err)
        this.router.navigate(['/dashboard']);
      }
    );

  }

  getOfferLetter() {
    let filter = {
      include: [{
          relation: 'attachments',
          scope: {
            where: {
              'or': [
                {
                  'type': 'jompay_offer_letter',
                  'isDeleted': false
                },
                {
                  'type': 'signed_jompay_lo',
                  'isDeleted': false
                },
                {
                  'type': 'signed_jompay_sa',
                  'isDeleted': false
                },
                {
                  'type': 'signed_jompay_accauth',
                  'isDeleted': false
                },
              ]
            },
            include: 'detail',
            order: 'created_at ASC'
          }
        },
        {
          relation: 'submission_subtags',
          scope: {
            where: {
              'deleted_at': null
            }
          }
        }
      ]
    };

    return this.payeeSubmissionApi.findById(this.submission.submission_id, filter);
  }

  addEventListeners() {}

  downloadPDF(file: string) {

    switch (file) {
      case 'offerLetter':
        this.offerLetter.nativeElement.click();
        break;
      case 'serviceAgreement':
        this.serviceAgreement.nativeElement.click();
        break;
      case 'authLetterCollectionAcc':
        console.log(this.authLetterCollectionAccSrc);
        this.authLetterCollectionAcc.nativeElement.click();
        break;
    }
    // var win = open(this.mobileSrc,'windowName','height=300,width=300');
    // win.document.write("");
    // window.open(this.mobileSrc);

    // this.download(this.file_name);
    // let url=this.mobileSrc;
    // this.http.get(url).map(
    //     (res) => {
    //         console.log(res);
    //         return new Blob([res.blob()], { type: 'application/pdf' })
    //     })
  }


  // Scrolling
  scrollToTop() {
    window.scroll(0, 0);
    document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = 0;
  }

  scrollToSave() {
    document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = document.getElementById('save_checklist').offsetTop;
  }

}
